import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import movieFetch from "../../redux/movie/movieAction";

// Components
// import MovieCard from "../../components/movieCard/index";
import TopHeader from "./TopHeader/index";
import Compnies from "./Compnies/index";
import Popular from "./Popular/index";
import JoinMovie from "./JoinMovie/index";
import Invite from "./Invite/index";
import Review from "./Review/index";
import Download from "./Download/index";

const Index = () => {
  const dispatch = useDispatch();
  // const movieState = useSelector((state) => state.movieState);
  useEffect(() => {
    dispatch(movieFetch());
  }, [dispatch]);
  return (
    <>
      <div className="lg:pt-24">
        <div className="p-4 lg:px-24">
          <TopHeader />
          <Compnies />
          <Popular />
        </div>
        <JoinMovie />
        <div className="p-4 lg:px-24">
          <Invite />
          <Review />
        </div>
        <Download />
      </div>
    </>
  );
};

export default Index;
